import normalizeUrl from '../../../../shared/utils/normalizeUrl';

export const MRP_PATHS = {
  'en-CA': normalizeUrl('/info/'),
  'fr-CA': normalizeUrl('/info/'),
};

export const DEFAULT_LOCALE_PATH = MRP_PATHS['en-CA'];
